import type { BTCalculatorState, ValidatedForm } from './types';
export const formatCurrency = ({
  amount,
  maximumFractionDigits = 0,
  minimumFractionDigits = 0,
}: {
  amount: number;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
}) => {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const formatInputDisplayValue = (value: string) => {
  if (value === '') return value;
  let stringClosure = '';

  if (value.endsWith('.')) {
    // Prevents deleting decimal dot when calling Number
    stringClosure = '.';
  } else if (value.endsWith('.0')) {
    // Allows 0 as the first decimal
    stringClosure = '.0';
  }

  return `${Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}${stringClosure}`;
};

const calculateBalanceTransferFee = (form: ValidatedForm) => {
  return Math.round(form.debt * form.balanceTransferFee);
};

const calculateInterestWithExistingDebt = (form: ValidatedForm) => {
  const { interestRate, debt, zeroInterestPeriod } = form;
  if (interestRate === 0) return 0;

  // Math taken from Wordpress Calculated fields form id "654"
  const rate = interestRate / 1200;

  if (rate === 0) return 0;

  const result =
    zeroInterestPeriod * ((rate * debt) / (1 - (1 + rate) ** (-1 * zeroInterestPeriod))) - debt;

  return Math.round(result);
};

export const calculateFormResults = (form: ValidatedForm): BTCalculatorState['results'] => {
  const balanceTransferFee = calculateBalanceTransferFee(form);
  const interestWithExistingDebt = calculateInterestWithExistingDebt(form);

  return {
    balanceTransferFee,
    interestWithExistingDebt,
    savings: interestWithExistingDebt - balanceTransferFee,
  };
};
